import { FilterAltOutlined } from '@mui/icons-material';

import { tCommon } from '@frontend/locales';

import { IconActionButton } from './icon-action-button.component';

export interface FilterActionProps {
  onClick(): void;
}

export const FilterAction = (props: FilterActionProps) => {
  return (
    <>
      <IconActionButton
        icon={<FilterAltOutlined />}
        onClick={props.onClick}
        title={tCommon.actions.filter()}
        ariaDescription={tCommon.actions.filter()}
      />
    </>
  );
};
